import i18n from "@/i18n";

export default [
  {
    path: "/base-knowledge",
    name: "UnterrichtBaseKnowledge",
    meta: {
      title: String(i18n.t("unterricht.base_knowledge")),
      trans: "unterricht.base_knowledge",
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/UnterrichtKnowledge/BaseKnowledge/UnterrichtBaseKnowledge.vue"),
  },
  {
    path: "/additional-knowledge-a",
    name: "UnterrichtAdditionalKnowledgeForA",
    meta: {
      title: String(i18n.t("unterricht.additional_knowledge_a")),
      trans: "unterricht.additional_knowledge_a",
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/UnterrichtKnowledge/AdditionalForA/UnterrichtAdditionalKnowledgeForA.vue"),
  },
  {
    path: "/additional-knowledge-b",
    name: "UnterrichtAdditionalKnowledgeForB",
    meta: {
      title: String(i18n.t("unterricht.additional_knowledge_b")),
      trans: "unterricht.additional_knowledge_b",
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/UnterrichtKnowledge/AdditionalForB/UnterrichtAdditionalKnowledgeForB.vue"),
  },
  {
    path: "/configuration",
    name: "UnterrichtConfiguration",
    meta: {
      title: String(i18n.t("unterricht.configuration")),
      trans: "unterricht.configuration",
    },
    component: () => import(/* webpackChunkName: "configuration" */ "@/views/UnterrichtDashboard/Configuration/UnterrichtConfiguration.vue"),
  },
];
